import { ReactNode } from 'react'

import { Box } from '@chakra-ui/react'

import { VIDEO_ASPECT_RATIO_PADDING } from '../constants/dimensions'

interface VideoChunkSurfaceIProps {
  children: ReactNode
  placeholderHeight?: string
  placeholderWidth?: string
  borderRadius?: string
}

/**
 * The black 16:9 box `LiveKitVideoPlayer` renders into, without the player
 * itself. Shared by the code-split boundary's spinner fallback and its error
 * state so that fetching — or failing to fetch — the chunk occupies exactly
 * the space the loaded player will, with no layout jump either way.
 */
export const VideoChunkSurface = ({
  children,
  placeholderHeight,
  placeholderWidth,
  borderRadius = '0.375rem',
}: VideoChunkSurfaceIProps) => (
  <Box
    bg='black'
    borderRadius={borderRadius}
    overflow='hidden'
    position='relative'
  >
    <Box
      minH={placeholderHeight}
      minW={placeholderWidth}
      pt={VIDEO_ASPECT_RATIO_PADDING}
    >
      {children}
    </Box>
  </Box>
)
